module.exports = __webpack_public_path__ + "static/media/logo.8e956a32.svg";